<template>
  <v-layout row justify-center>
    <v-dialog v-model="windowVisible" persistent max-width="600px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>Copy Flow Type</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="close"><v-icon>close</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="currentCategory" label="Category" disabled></v-text-field>
                <kendo-dropdownlist
                  style="width:100%"
                  :data-source="clients"
                  :data-text-field="'name'"
                  :data-value-field="'clientId'"
                  :filter="'contains'"
                  :options-label="'From'"
                  v-model="firstClientId"
                ></kendo-dropdownlist>

                <v-text-field v-model="currentClient" label="To" disabled></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue primary" @click="save">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import notification from '@/helpers/notification'

export default {
  name: 'CopyTo',
  props: {
    windowVisible: {type: Boolean, default: false},
    categoryId: {default: 0},
  },
  mounted() {},
  data() {
    return {
      currentCategory: 'foo',
      currentClient: 'bar',
      clients: new kendo.data.DataSource({
        data: [],
        schema: {
          model: {
            fields: {
              clientId: {type: 'number'},
              name: {type: 'string'},
            },
          },
        },
      }),
      firstClientId: 0,
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  watch: {
    windowVisible(newValue) {
      if (newValue) this.getClients()
    },
  },
  methods: {
    close() {
      this.clients.data([])
      this.$emit('close')
    },
    getClients: async function() {
      const req = await axios
        .get('/api/config/client/getClientsWithCategory', {
          params: {
            clientId: this.clientId,
            categoryId: this.categoryId,

            t: new Date().getTime(),
          },
        })
        .catch(() => notification('Error ', 'error'))
      let data = req.data
      this.currentCategory = data.currentCategory
      this.clients.data(data.clients)
      this.currentClient = data.currentClient
      this.firstClientId = data.clientId
    },
    save: function() {
      axios
        .post('/api/config/client/copyFlowTypes', {
          clientId: +this.clientId,
          fromClientId: +this.firstClientId,
          categoryId: +this.categoryId,
        })
        .then(response => {
          if (response.status == 200) {
            this.$emit('save')
            let responseType = response.headers['content-type']
            if (responseType.includes('application/json')) {
              let parseResponse = response.data
              if (parseResponse.message) {
                notification(parseResponse.message)
              }
            }
            this.close()
          }
        })
        .catch(() => notification('Some error', 'error'))
    },
  },
}
</script>
